<template>
    <div>
        <!-- サブテキスト設定時 -->
        <v-tooltip right v-if="item.text">
            <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-icon>{{ item.icon }}</v-icon>
                            {{ item.name }}
                            <v-btn icon v-if="item.subMenuFlg == true">
                                <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item-content>
                </div>
            </template>
            <span>{{ item.text }}</span>
        </v-tooltip>

        <!-- サブテキスト未設定時 -->
        <div v-if="!item.text">
            <v-list-item-content>
                <v-list-item-title>
                    <v-icon>{{ item.icon }}</v-icon>
                    {{ item.name }}
                    <v-btn icon v-if="item.subMenuFlg == true">
                        <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                    </v-btn>
                </v-list-item-title>
            </v-list-item-content>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item'],
}
</script>



